import { useUserContext } from "@/features/auth/contexts/useUserContext";
import { Button } from "@/features/common/components/Button";
import { MobileFilterDialogViewProps } from "@/features/common/components/filter/MobileFilterDialogView";
import {
  DialogViewEnum,
  useDialogContext,
} from "@/features/common/contexts/useDialogContext";
import FilterIcon from "@/icons/filter.svg";
import { cn } from "@/lib/utils";

export const FilterStagger = ({
  filterList,
  className = "",
}: MobileFilterDialogViewProps & {
  className?: string;
}) => {
  const { openDialog } = useDialogContext();
  const { user } = useUserContext();

  const onOpenFilter = () => {
    openDialog({ view: DialogViewEnum.MobileFilterDialog, filterList });
  };

  return (
    <Button
      size="sm"
      className={cn(
        "fixed right-4 z-50 h-11 !w-auto space-x-1 rounded-full",
        className,
        user ? "bottom-16" : "bottom-5",
      )}
      onClick={onOpenFilter}
    >
      <FilterIcon />
      <span>篩選器</span>
    </Button>
  );
};
